const ACTIVE_ROOT_KEY = 'portrait_active_root';

interface ActiveRootRecord {
  rootId: string;
  token?: string;
  date: string;
}

function todayKey() {
  return new Date().toISOString().slice(0, 10);
}

export function readActiveRoot() {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(ACTIVE_ROOT_KEY) || 'null') as ActiveRootRecord | null;
    if (!parsed?.rootId || parsed.date !== todayKey()) return undefined;
    return parsed;
  } catch {
    return undefined;
  }
}

export function rememberActiveRoot(rootId?: string, token?: string) {
  if (!rootId) return;
  window.localStorage.setItem(
    ACTIVE_ROOT_KEY,
    JSON.stringify({
      rootId,
      token,
      date: todayKey()
    })
  );
}
